(function () {
  // Pinta el carrito lateral con el HTML nuevo y quita el estado "vacío" si ya hay productos
  function refreshDrawerFromHTML(html) {
    if (!html) return false;
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var freshDrawer = doc.querySelector('cart-drawer');
      var liveDrawer = document.querySelector('cart-drawer');
      if (!freshDrawer || !liveDrawer) return false;
      liveDrawer.innerHTML = freshDrawer.innerHTML;
      // El primer producto llega con el cajón marcado como vacío: sin esto se queda en blanco
      liveDrawer.classList.toggle('is-empty', freshDrawer.classList.contains('is-empty'));
      var items = liveDrawer.querySelector('cart-drawer-items');
      if (items) items.classList.toggle('is-empty', freshDrawer.querySelector('cart-drawer-items.is-empty') !== null);
      // Imágenes visibles al momento, sin esperar a la carga diferida
      liveDrawer.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
      return true;
    } catch (e) {
      return false;
    }
  }

  // Si la respuesta no trae el HTML del carrito, se pide aparte
  function fetchDrawer() {
    return originalFetch('/?section_id=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(refreshDrawerFromHTML)
      .catch(function () { return false; });
  }

  function openDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    }
  }

  var originalFetch = window.fetch;
  window.fetch = function () {
    var request = arguments[0];
    var url = typeof request === 'string' ? request : (request && request.url) || '';
    var promise = originalFetch.apply(this, arguments);
    var isCartEndpoint =
      url.indexOf('/cart/add') !== -1 ||
      url.indexOf('/cart/change') !== -1 ||
      url.indexOf('/cart/update') !== -1;

    if (isCartEndpoint) {
      promise
        .then(function (response) {
          if (!response || !response.ok) return;
          response
            .clone()
            .json()
            .then(function (data) {
              var done = data && data.sections && data.sections['cart-drawer']
                ? Promise.resolve(refreshDrawerFromHTML(data.sections['cart-drawer']))
                : fetchDrawer();
              done.then(function () {
                if (url.indexOf('/cart/add') !== -1) setTimeout(openDrawer, 100);
              });
            })
            .catch(function () {});
        })
        .catch(function () {});
    }
    return promise;
  };
})();
